import { booleanAttribute, Component, inject, Input, Output, NgModule, numberAttribute, OnInit, ViewEncapsulation, EventEmitter, ValueEqualityFn } from '@angular/core';
import {CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { CommonModule, Time } from '@angular/common';
import { Observable, BehaviorSubject, Subject, of } from 'rxjs';
import { MatButton } from '@angular/material/button';
import { MatCard } from '@angular/material/card';
import { MatList, MatListItem, MatListItemIcon } from '@angular/material/list';
import { MatIcon } from '@angular/material/icon';
import { MatToolbar, MatToolbarRow } from '@angular/material/toolbar';
import { MatDivider } from '@angular/material/divider';
import { AppConfigService } from '../../Services/app-config.service';
import { AudioService } from 'src/app/Services/audio.service';
import { StreamState } from 'src/app/interfaces/stream-state';
import { Event, Router } from '@angular/router';
import { MatSliderModule } from '@angular/material/slider';
import { MatSliderThumb } from '@angular/material/slider';
import * as moment from 'moment';
import { ThemePalette } from '@angular/material/core';
import { MaterialModule } from 'src/app/material.module';
import { MatSliderDragEvent } from '@angular/material/slider';
import { MatSliderRangeThumb } from '@angular/material/slider';
import { MatInputModule } from '@angular/material/input';
import { MatInput } from '@angular/material/input';
import { NumberInput } from '@angular/cdk/coercion';
import { MatSlider } from '@angular/material/slider';

@Component({
  selector: 'app-audio-player',
  templateUrl: './audio-player.component.html',
  styleUrls: ['./audio-player.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class AudioPlayerComponent implements OnInit {
  @Input() audioFile: string = ''; 
  @Input() displayname: string | any; 

  // @Input({ transform: booleanAttribute })
  // disableRipple: boolean | undefined; 

  // @Input({ transform: booleanAttribute }) 
  // disabled: boolean | undefined; 
  
  // @Input({ transform: booleanAttribute }) 
  // discrete: boolean | undefined; 

  // @Input() displayWith: 
  // ((value: number) =>
  //     string | undefined) | undefined; 

  @Input({ transform: numberAttribute })
  value: number | any; 

  @Output()
  valueChange: EventEmitter<number> | any;
   

  // @Input({ transform: numberAttribute })
  // max: number | undefined; 

  // @Input({ transform: numberAttribute })
  // min: number | undefined; 

  // @Input({ transform: booleanAttribute })
  // showTickMarks: boolean | undefined; 

  // @Input({ transform: numberAttribute }) 
  // step: number | undefined; 

  // percentage: number | undefined; 
  // currentTime: number | undefined;

  formatLabel(time: number, format: string = 'm:ss') {
    const momentTime = time * 1000;
    if (time >= .5) {
      return moment.utc(momentTime).format(format);    }

    return `${momentTime}`;
  }

  audiopath = '';
  OBPortalSvcURL = '';

  files: Array<any> = [];
  state: StreamState | any;
  currentFile: any = {};
  
  muted: boolean | undefined;
  mutestate: boolean | undefined; 

  click: any;

  constructor(
    private router: Router, 
    private appConfigService: AppConfigService,
    private audioService: AudioService,
  ) {    
    this.audioService.getFiles().subscribe(files => {
      this.files = files;
    });

    this.audioService.getState().subscribe(state => {
      this.state = state;
    });
    
  }

  ngOnInit(): void {
    this.OBPortalSvcURL = this.appConfigService.OBPortalSvcURL;
    // this.audiopath = this.appConfigService.audiopath;
  }

  ngOnDestroy(): void { 
    this.audioService.stop();
  }
  // ngOnChanges(changes: any) {
  //   this.openFile('', 0, '')  
  //   this.playStream(this.audioFile)
  // }

  // playStream(filename: any) {
  //   var path = this.appConfigService.audiopath; 
  //   this.audioService.playStream(path + filename).subscribe(events => {
  //   });
  // }
  // getFiles() {
  //   return of(this.files);
  // }
  // openFile(file: any, index: any, filename: any) {
  //   this.currentFile = { file, index, filename };
  //   this.audioService.stop();
  //   this.playStream(filename);
  // }
  pause() {
    this.audioService.pause();
  }
  play() {
    this.audioService.play();
  }
  stop() {
    this.audioService.stop();
  }
  setMute(muted: boolean) {
    this.audioService.setMute(muted); 
    this.mutestate=muted;
  }
  forward() { 
    this.audioService.forward();
  }
  rewind() { 
    this.audioService.rewind();
  }
  skipintro() { 
    this.audioService.skipintro();
  }

  
 
  onSliderChangeEnd(change: any) {
    this.audioService.seekTo(change.value);
    // value should be a different color than change
  }
 

}

